import { format } from 'date-fns'
import React, { useCallback, KeyboardEvent } from 'react'
import { usePassedState } from '../../../../hooks/use-passed-state'
import { Date } from '../../../date'
import { FilterProps } from '../../utils'

export function FilterDate({ value, labelledBy, dateFormat, onKeyDown }: FilterProps) {
  if (typeof value !== 'string') throw new Error('Invalid value type for `date`')
  const { state: internalState, setState: setInternalState } = usePassedState<string>(value)

  const setState = useCallback(
    (date: Date) => {
      const dateString = format(date, dateFormat)
      setInternalState(dateString)
    },
    [dateFormat, setInternalState],
  )

  const onKeyDownHandler = onKeyDown as unknown as ((event: KeyboardEvent<HTMLDivElement>) => void) | undefined

  return (
    <div>
      <Date
        // Accessibility
        ariaLabelledBy={labelledBy}
        // Value props
        onChange={setState}
        value={internalState}
        dateFormat={dateFormat}
        // Styles
        className='c-form-date-field__input'
        onKeyDown={onKeyDownHandler}
      />
    </div>
  )
}
